export * from './user-setting.actions';
export * from './user-setting.reducers';
export * from './user-setting.selectors';

import * as UserSettingAction from './user-setting.actions';
export { UserSettingAction };
